var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 2.5C0.25 1.25736 1.25736 0.25 2.5 0.25H11.5C12.7427 0.25 13.75 1.25736 13.75 2.5V11.5C13.75 12.7427 12.7427 13.75 11.5 13.75H2.5C1.25736 13.75 0.25 12.7427 0.25 11.5V2.5ZM2.5 1.75C2.08579 1.75 1.75 2.08579 1.75 2.5V11.5C1.75 11.9142 2.08579 12.25 2.5 12.25H11.5C11.9142 12.25 12.25 11.9142 12.25 11.5V2.5C12.25 2.08579 11.9142 1.75 11.5 1.75H2.5ZM3.46967 4.96967C3.76257 4.67678 4.23744 4.67678 4.53033 4.96967L6.03032 6.46968C6.3232 6.76255 6.3232 7.23745 6.03032 7.53032L4.53033 9.03032C4.23744 9.3232 3.76257 9.3232 3.46967 9.03032C3.17678 8.73745 3.17678 8.26255 3.46967 7.96968L4.43934 7L3.46967 6.03032C3.17678 5.73745 3.17678 5.26256 3.46967 4.96967ZM7 8.5C7 8.08577 7.33577 7.75 7.75 7.75H10C10.4142 7.75 10.75 8.08577 10.75 8.5C10.75 8.91422 10.4142 9.25 10 9.25H7.75C7.33577 9.25 7 8.91422 7 8.5Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.17c7b1fc446cc34d62366348f0a805f9.svg";
export { ForwardRef as ReactComponent };